export function Field({ label, children }: any) {
    return (
        <label className="grid gap-1 text-sm">
            <span className="text-gray-600">{label}</span>
            {children}
        </label>
    );
}